import './../Status.scss';
import React from 'react';
import { useEffect, useRef, useState } from 'react'
import { useAppSelector } from '../../../../redux/hooks';
import { useDispatch } from 'react-redux';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Plot from "react-plotly.js";

interface Props {
    index: number;
    plotHeight: number;
}

export default function BF(props: Props) {
    let ColorScale_Normal: Array<any> = [
        ['0.0', 'rgb(49,54,149)'],
        ['0.05', 'rgb(69,117,180)'],
        ['0.1', 'rgb(116,173,209)'],
        ['0.15', 'rgb(171,217,233)'],
        ['0.2', 'rgb(224,243,248)'],
        ['0.3', 'rgb(254,224,144)'],
        ['0.4', 'rgb(253,174,97)'],
        ['0.6', 'rgb(244,109,67)'],
        ['0.8', 'rgb(215,48,39)'],
        ['1.0', 'rgb(165,0,38)']];

    var layout_bfl1_init = {
        height: props.plotHeight,
        title: {
            text: 'Sky Plot',
            font: {
                color: 'white',
                size: 12
            }
        },
        margin: {
            l: 2,
            r: 2,
            b: 2,
            t: 30,
            pad: 0
        },
        showlegend: false,
        legend: {
            font: {color: 'white'},
            xanchor: 'right',
            yanchor: 'top'
        },
        xaxis: {
            title: {
                text: '',
                font: {
                    color: 'white'
                }
            },
            dtick:30,
            autorange: true,
            range:  [-100, 100],
            tickcolor: 'black',
            tickfont: {
                color: 'white'
            },
            gridcolor: "rgb(110, 110, 50)",
            mirror: true,
            linewidth: 1,
            linecolor: "rgb(255, 255, 140)",
            scaleanchor: 'y',
            showticklabels: false
        },
        yaxis : {
            title: {
                text: '',        
                font: {
                    color: 'white'
                }
            },        
            dtick:30,
            autorange: true,
            range:  [-100, 100],
            tickcolor: 'black',
            tickfont: {
                color: 'white'
            },
            gridcolor: "rgb(110, 110, 50)",
            mirror: true,
            linewidth: 1,
            linecolor: "rgb(255, 255, 140)",
            showticklabels: false
        },
        plot_bgcolor :"black",
        paper_bgcolor:"black"
    };
    const [layout_bfl1, setBFL1Layout] = useState(layout_bfl1_init);
    let data_bfl1_init: Array<any> = [];
    data_bfl1_init.push({
        x: [],
        y: [],
        mode: "lines",
        name: '',
        line: {color: "rgb(255, 255, 255)"}
    });
    const [data_bfl1, setBFL1Data] = useState(data_bfl1_init);
    var layout_bfl2_init = {
        height: props.plotHeight,
        title: {
            text: 'Sky Plot',
            font: {
                color: 'white',
                size: 12
            }
        },
        margin: {
            l: 2,
            r: 2,
            b: 2,
            t: 30,
            pad: 0
        },
        showlegend: false,
        legend: {
            font: {color: 'white'},
            xanchor: 'right',
            yanchor: 'top'
        },
        xaxis: {
            title: {
                text: '',
                font: {
                    color: 'white'
                }
            },
            dtick:30,
            autorange: true,
            range:  [-100, 100],
            tickcolor: 'black',
            tickfont: {
                color: 'white'
            },
            gridcolor: "rgb(110, 110, 50)",
            mirror: true,
            linewidth: 1,
            linecolor: "rgb(255, 255, 140)",
            scaleanchor: 'y',
            showticklabels: false
        },
        yaxis : {
            title: {
                text: '',        
                font: {
                    color: 'white'
                }
            },        
            dtick:30,
            autorange: true,
            range:  [-100, 100],
            tickcolor: 'black',
            tickfont: {
                color: 'white'
            },
            gridcolor: "rgb(110, 110, 50)",
            mirror: true,
            linewidth: 1,
            linecolor: "rgb(255, 255, 140)",
            showticklabels: false
        },
        plot_bgcolor :"black",
        paper_bgcolor:"black"
    };
    const [layout_bfl2, setBFL2Layout] = useState(layout_bfl2_init);
    let data_bfl2_init: Array<any> = [];
    data_bfl2_init.push({
        x: [],
        y: [],
        mode: "lines",
        name: '',
        line: {color: "rgb(255, 255, 255)"}
    });
    const [data_bfl2, setBFL2Data] = useState(data_bfl2_init);

    const dispatch = useDispatch();
    const layerData = useAppSelector(state => state.layerData);
    
    const SNTime = layerData.status.Time;
    const Status = layerData.status.GristStatus;
    
    function setBF(index: number) {
        let bf: Array<any> = [];
        let BFx: Array<number> = [];
        let BFy: Array<number> = [];
        for(var m = -90; m <= 90; m += 1) {
            BFx.push(m);
            BFy.push(m);
        }
        let BFz: Array<any> = [];
        let Jammerx: Array<number> = [];
        let Jammery: Array<number> = [];
        let Spooferx: Array<number> = [];
        let Spoofery: Array<number> = [];
        let Satx: Array<number> = [];
        let Saty: Array<number> = [];
        let Sattext: Array<string> = [];
        let bfl1Data: Array<object> = [];
        BFz = [];
        if(Status[props.index].BF.Array[index].Beamformer.length > 0) {
            var dMaxPower = -9999.0;
            for(var m = 0; m < Status[props.index].BF.Array[index].Beamformer.length; ++m) {
                for(var n = 0; n < Status[props.index].BF.Array[index].Beamformer[m].length; ++n) {
                    if(dMaxPower < Status[props.index].BF.Array[index].Beamformer[m][n]) {
                        dMaxPower = Status[props.index].BF.Array[index].Beamformer[m][n];
                    }
                }
            }
            var dEleStep = 90.0 / Status[props.index].BF.Array[index].Beamformer.length;
            let vdAziStep: Array<number> = [];
            for(var m = 0; m < Status[props.index].BF.Array[index].Beamformer.length; ++m) {
                var dAziStep = 360.0 / Status[props.index].BF.Array[index].Beamformer[m].length;
                vdAziStep.push(dAziStep);
            }
            for(var  m = -90; m <= 90; ++m) {
                let BFz_row: Array<any> = [];
                for(var n = -90; n <= 90; ++n) {
                    var dR2 = m * m + n * n;
                    if(dR2 < 8100.0) {
                        var dEle = 90.0 - Math.sqrt(m * m + n * n);
                        var dAzi = Math.atan2(n , m) * 180.0 / Math.PI;
                        var iEleIndex = Math.round((dEle - dEleStep * 0.5) / dEleStep);
                        if(iEleIndex < 0) {
                            iEleIndex = 0;
                        }
                        if(iEleIndex >= Status[props.index].BF.Array[index].Beamformer.length) {
                            iEleIndex = Status[props.index].BF.Array[index].Beamformer.length - 1;
                        }
                        var iAziIndex = Math.round((dAzi - vdAziStep[iEleIndex] * 0.5) / vdAziStep[iEleIndex]);
                        while(iAziIndex < 0) {
                            iAziIndex += Status[props.index].BF.Array[index].Beamformer[iEleIndex].length;
                        }
                        while(iAziIndex >= Status[props.index].BF.Array[index].Beamformer[iEleIndex].length) {
                            iAziIndex -= Status[props.index].BF.Array[index].Beamformer[iEleIndex].length;
                        }
                        BFz_row.push(Status[props.index].BF.Array[index].Beamformer[iEleIndex][iAziIndex]);
                    } else {
                        BFz_row.push(0.0 / 0.0);
                    }
                }
                BFz.push(BFz_row);
            }
        } else {
            for(var  m = -90; m <= 90; ++m) {
                let BFz_row: Array<any> = [];
                for(var n = -90; n <= 90; ++n) {
                    BFz_row.push(0.0 / 0.0);
                }
                BFz.push(BFz_row);
            }
        }
        var data3d = {
            z: BFz,
            x: BFx,
            y: BFy,
            zauto: false,
            zmin: -120,
            zmax: -90,
            zsmooth: 'best',
            type: 'heatmap',
            colorscale: ColorScale_Normal,
            showscale: false,
            connectgaps: false,
            name: "BF",
        };
        bf.push(data3d);
        Jammerx = [];
        Jammery = [];
        for(var m = 0; m < Status[props.index].BF.Array[index].Jammer.x.length; ++m) {
            Jammerx.push(Status[props.index].BF.Array[index].Jammer.x[m]);
            Jammery.push(Status[props.index].BF.Array[index].Jammer.y[m]);
        }
        var dataJammer = {
            x: Jammerx,
            y: Jammery,
            mode: "lines",
            name: "Jammer",
            line: {color: "rgb(255, 0, 255)"}
        };
        bf.push(dataJammer);
        Spooferx = [];
        Spoofery = [];
        for(var m = 0; m < Status[props.index].BF.Array[index].Spoofer.x.length; ++m) {
            Spooferx.push(Status[props.index].BF.Array[index].Spoofer.x[m]);
            Spoofery.push(Status[props.index].BF.Array[index].Spoofer.y[m]);
        }
        var dataSpoofer = {
            x: Spooferx,
            y: Spoofery,
            mode: "lines",
            name: "Spoofer",
            line: {color: "rgb(255, 255, 0)"}
        };
        bf.push(dataSpoofer);
        Satx = [];
        Saty = [];
        Sattext = [];
        for(var m = 0; m < Status[props.index].BF.Array[index].Sat.x.length; ++m) {
            Satx.push(Status[props.index].BF.Array[index].Sat.x[m]);
            Saty.push(Status[props.index].BF.Array[index].Sat.y[m]);
            Sattext.push(Status[props.index].BF.Array[index].Sat.text[m]);
        }
        var dataSat = {
            x: Satx,
            y: Saty,
            text: Sattext,
            mode: 'markers+text',
            type: 'scatter',
            name: 'Tracking Sat',
            textfont: { size: 15, color: 'white' },
            textposition: 'bottom center',
            marker: {
                size: 10, 
                symbol: 'circle',
                color: 'yellow'
            }
        };
        bf.push(dataSat);

        if(index == 0) {
            setBFL1Data(bf);
        } else if(index == 1) {
            setBFL2Data(bf);
        }
    }
    
    function initBF(index: number) {
        let bf: Array<any> = [];
        bf.push({
            x: [],
            y: [],
            mode: "lines",
            name: '',
            line: {color: "rgb(255, 255, 255)"}
        });
        if(index == 0) {
            setBFL1Data(bf);
        } else if(index == 1) {
            setBFL2Data(bf);
        }
    }
    
    useEffect(() => {
        if((props.index >= 0) && (props.index < Status.length)) {
            if(Status[props.index].BF.Array.length >= 2) {
                var localTime = new Date(Status[props.index].BF.Time);
                setBF(0);
                setBF(1);
                var bfl1_layout = layout_bfl1;
                bfl1_layout.title.text = Status[props.index].Name + ' Sky Plot L1 ' + localTime.toLocaleString();
                setBFL1Layout(bfl1_layout);
                var bfl2_layout = layout_bfl2;
                bfl2_layout.title.text = Status[props.index].Name + ' Sky Plot L2 ' + localTime.toLocaleString();
                setBFL2Layout(bfl2_layout);
            } else {
                initBF(0);
                initBF(1);
            }
        } else {
            initBF(0);
            initBF(1);
            var bfl1_layout = layout_bfl1;
            bfl1_layout.title.text = 'Sky Plot L1';
            setBFL1Layout(bfl1_layout);
            var bfl2_layout = layout_bfl2;
            bfl2_layout.title.text = 'Sky Plot L2';
            setBFL2Layout(bfl2_layout);
        } 
        
    }, [SNTime]);
    
    useEffect(() => {
        var bfl1_layout = layout_bfl1;
        bfl1_layout.height = props.plotHeight;
        setBFL1Layout(bfl1_layout);
        var bfl2_layout = layout_bfl2;
        bfl2_layout.height = props.plotHeight;
        setBFL2Layout(bfl2_layout);
    }, [props.plotHeight]);

    return (
        <div>
            <Table><TableBody><TableRow className='graph_d_row' style={{border: '1px solid rgba(0, 0, 0, 1)', backgroundColor: 'black', height: '10%', alignItems: 'center'}}>
                <TableCell style={{border: '10px solid rgba(0, 0, 0, 1)', width: '95%', backgroundColor: 'black'}} padding='none'>
                    <Plot data={data_bfl1 as any} layout={layout_bfl1 as any} useResizeHandler={true} style={{ width: '100%', height: '100%'}}/>
                </TableCell>
                <TableCell style={{border: '10px solid rgba(0, 0, 0, 1)', width: '95%', backgroundColor: 'black'}} padding='none'>
                    <Plot data={data_bfl2 as any} layout={layout_bfl2 as any} useResizeHandler={true} style={{ width: '100%', height: '100%'}}/>
                </TableCell>
            </TableRow></TableBody></Table>
        </div>
    )
}
